// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._15gua2a0 {
  flex-basis: 50%;
  max-width: 50%;
}
._15gua2a1 {
  background-color: white;
}
._15gua2a2 {
  flex-basis: 50%;
  max-width: 50%;
  padding: var(--_18w76bwg);
  padding-bottom: 0px;
}
._15gua2a3 {
  flex-basis: 50%;
  max-width: 50%;
  padding: var(--_18w76bwg);
}
._15gua2a4 {
  flex-basis: 50%;
  max-width: 50%;
  padding: var(--_18w76bwe) var(--_18w76bwg);
  background-color: var(--_18w76bw26);
}
._15gua2a5 {
  gap: var(--_18w76bwi);
}
._15gua2a6 {
  margin-left: auto;
}
._15gua2a7 {
  flex-basis: 50%;
  max-width: 50%;
  padding: var(--_18w76bwg);
}
@media screen and (min-width:768px) {
  ._15gua2a0 {
    flex-basis: 41.66667%;
    max-width: 41.66667%;
  }
  ._15gua2a2 {
    padding: 0px;
    flex-basis: 16.66667%;
    max-width: 16.66667%;
  }
  ._15gua2a3 {
    padding: 0px;
    flex-basis: 8.33333%;
    max-width: 8.33333%;
  }
  ._15gua2a4 {
    padding: 0px;
    background-color: unset;
  }
  ._15gua2a5 {
    flex-basis: 12%;
    max-width: 12%;
  }
  ._15gua2a6 {
    flex-basis: 5%;
    max-width: 5%;
  }
  ._15gua2a7 {
    padding: 0px;
    flex-basis: 21%;
    max-width: 21%;
  }
}
@media screen and (min-width: 768px) {
  ._15gua2a1:nth-child(even) {
    background-color: var(--_18w76bw26);
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,cAAc;EACd,0CAA0C;EAC1C,mCAAmC;AACrC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE;IACE,qBAAqB;IACrB,oBAAoB;EACtB;EACA;IACE,YAAY;IACZ,qBAAqB;IACrB,oBAAoB;EACtB;EACA;IACE,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,YAAY;IACZ,eAAe;IACf,cAAc;EAChB;AACF;AACA;EACE;IACE,mCAAmC;EACrC;AACF","sourcesContent":["._15gua2a0 {\n  flex-basis: 50%;\n  max-width: 50%;\n}\n._15gua2a1 {\n  background-color: white;\n}\n._15gua2a2 {\n  flex-basis: 50%;\n  max-width: 50%;\n  padding: var(--_18w76bwg);\n  padding-bottom: 0px;\n}\n._15gua2a3 {\n  flex-basis: 50%;\n  max-width: 50%;\n  padding: var(--_18w76bwg);\n}\n._15gua2a4 {\n  flex-basis: 50%;\n  max-width: 50%;\n  padding: var(--_18w76bwe) var(--_18w76bwg);\n  background-color: var(--_18w76bw26);\n}\n._15gua2a5 {\n  gap: var(--_18w76bwi);\n}\n._15gua2a6 {\n  margin-left: auto;\n}\n._15gua2a7 {\n  flex-basis: 50%;\n  max-width: 50%;\n  padding: var(--_18w76bwg);\n}\n@media screen and (min-width:768px) {\n  ._15gua2a0 {\n    flex-basis: 41.66667%;\n    max-width: 41.66667%;\n  }\n  ._15gua2a2 {\n    padding: 0px;\n    flex-basis: 16.66667%;\n    max-width: 16.66667%;\n  }\n  ._15gua2a3 {\n    padding: 0px;\n    flex-basis: 8.33333%;\n    max-width: 8.33333%;\n  }\n  ._15gua2a4 {\n    padding: 0px;\n    background-color: unset;\n  }\n  ._15gua2a5 {\n    flex-basis: 12%;\n    max-width: 12%;\n  }\n  ._15gua2a6 {\n    flex-basis: 5%;\n    max-width: 5%;\n  }\n  ._15gua2a7 {\n    padding: 0px;\n    flex-basis: 21%;\n    max-width: 21%;\n  }\n}\n@media screen and (min-width: 768px) {\n  ._15gua2a1:nth-child(even) {\n    background-color: var(--_18w76bw26);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
